export const BOOLEAN_OPTION_SET = {
  uds_hauptauto: {
    labels: { true: 'Hauptfahrzeug', false: 'Nebenfahrzeug' }
  },
  activeOrInactive: {
    labels: { true: 'Aktiv', false: 'Inaktiv' }
  }
};
